var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sessionless",class:_vm.getSessionlessClasses},[_c('p',{staticClass:"title",class:_vm.getSessionlessTitleClasses},[_vm._v(_vm._s(_vm.title))]),(_vm.$windowWidth > 700)?_c('p',{staticClass:"subtitle",class:_vm.topBarView ? 'sessionless--topBarView-subtitle' : ''},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }